<div class="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
  <div
    class="bg-white flex flex-col rounded-lg p-6 w-[600px] items-center justify-center relative shadow-lg"
  >
    <h2 class="text-xl font-bold mb-4">Actualizar imagen</h2>
    <div *ngIf="!hasImageChanged()" class="flex flex-col items-center">
      <label
        class="border-2 w-full border-dashed border-primary rounded-lg h-72 px-20 flex flex-col items-center justify-center cursor-pointer hover:bg-primary/5 transition text-center"
      >
        <input
          type="file"
          class="hidden"
          (change)="fileChangeEvent($event)"
          accept="image/jpeg,image/jpg,image/png"
        />
        <span class="text-primary font-medium"
          >Toca o haz clic para seleccionar una imagen</span
        >
        <small class="text-gray-500 mt-1"
          >Máx. 700 Kbs — Formato recomendado: cuadrado</small
        >
      </label>
    </div>
    <div
      *ngIf="hasImageChanged()"
      class="max-h-[70vh] max-w-[600px] overflow-auto"
    >
      <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        [aspectRatio]="
          cropType === 'square' ? 1 : cropType === 'rectangle2' ? 16 / 9 : 6 / 1
        "
        [resizeToWidth]="
          cropType === 'square' ? 500 : cropType === 'rectangle2' ? 1280 : 1600
        "
        format="jpeg"
        alignImage="center"
        (imageCropped)="imageCropped($event)"
      >
      </image-cropper>
    </div>
    <div class="flex justify-center gap-3 mt-6">
      <button
        (click)="cancel()"
        class="px-4 py-2 flex rounded items-center justify-center border border-gray-400 text-gray-600 hover:bg-gray-100 transition"
      >
        Cancelar
      </button>
      <app-loading-button
        [text]="'Actualizar'"
        (click)="confirm()"
        [loading]="loading"
        type="button"
      >
      </app-loading-button>
    </div>
  </div>
</div>
